// ─── Préférences d'affichage de SESSION ───────────────────────────
// Des choix d'écran qui survivent à la navigation mais pas au redémarrage
// (la bascule de synthèse, 16/08). Pas de Firestore : c'est un confort de
// lecture du moment, pas une donnée — et pas d'AsyncStorage non plus tant
// qu'aucun besoin de persistance n'est exprimé.
const prefs = new Map();

export const prefSession = (cle, defaut) => (prefs.has(cle) ? prefs.get(cle) : defaut);
export const definirPrefSession = (cle, valeur) => { prefs.set(cle, valeur); };
